import React from 'react';
import { Link } from 'react-router-dom';
import '@fontsource-variable/andada-pro';

const HomePage = () => {
  return (
    <div className="container">
      <div className="section center-align">
        <h2 className="white-text text-darken-4">🔮 Casa Arcana</h2>
        <p className="grey-text text-darken-1">
          Bienvenido a tu guía espiritual diaria.
        </p>
      </div>

      <div className="row">
        {/* Horóscopo Diario */}
        <div className="col s12 m6" style={{ marginBottom: '20px' }}>
          <div className="card indigo darken-3 hoverable" style={{ borderRadius: '15px' }}>
            <div className="card-content white-text">
              <span className="card-title">Horóscopo Diario</span>
              <p>Consulta las predicciones diarias de tu signo.</p>
            </div>
            <div className="card-action">
              <Link to="/horoscopo" className="white-text">Ir al horóscopo</Link>
            </div>
          </div>
        </div>

        {/* Frase del Día */}
        <div className="col s12 m6" style={{ marginBottom: '20px' }}>
          <div className="card deep-purple darken-2 hoverable" style={{ borderRadius: '15px' }}>
            <div className="card-content white-text">
              <span className="card-title">Frase del Día</span>
              <p>Recibe una frase inspiradora según tu signo.</p>
            </div>
            <div className="card-action">
              <Link to="/frase" className="white-text">Ver frase</Link>
            </div>
          </div>
        </div>

        {/* Compatibilidad */}
        <div className="col s12 m6" style={{ marginBottom: '20px' }}>
          <div className="card purple darken-3 hoverable" style={{ borderRadius: '15px' }}>
            <div className="card-content white-text">
              <span className="card-title">Compatibilidad de Signos</span>
              <p>Descubre qué signos son más compatibles contigo.</p>
            </div>
            <div className="card-action">
              <Link to="/compatibilidad" className="white-text">Explorar compatibilidad</Link>
            </div>
          </div>
        </div>

        {/* Tirada de Tarot 
        <div className="col s12 m6" style={{ marginBottom: '20px' }}>
          <div className="card pink darken-2 hoverable" style={{ borderRadius: '15px' }}>
            <div className="card-content white-text">
              <span className="card-title">Tirada de Tarot</span>
              <p>Haz una tirada gratuita de cartas para guiar tu día.</p>
            </div>
            <div className="card-action">
              <Link to="/tirada" className="white-text">Hacer tirada</Link>
            </div>
          </div>
        </div>*/}
      </div>

      <footer className="section center-align grey-text text-lighten-1">
        © 2025 Casa Arcana
      </footer>
    </div>
  );
};

export default HomePage;